/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from 'react';
import { Link } from "react-router-dom";
import intl from 'react-intl-universal';



import {getLinkForSignIn, isUserSignedIn, UserContext} from "../../UserContext";

import { linkForPlace } from "../LinkHelper";

import { getCountryName } from "./GeoCountries";
import RegionLevelCountries from "./RegionLevelCountries";

import Placeholder from "../../assets/image/placeholder/1920x800.png";
import UnsplashLogo from '../../assets/image/logo/unsplash_Logo.png';

class PlaceHero extends React.Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);

        const countryCode = this.props.countryCode;
        const countryName = countryCode && countryCode !== '' ? getCountryName(countryCode) : null;

        const regionName = this.props.regionName;
        const cityName = this.props.cityName;

        const parentRegion = cityName && regionName && RegionLevelCountries.is(countryCode) ? regionName : null;
        const parentCountry = cityName || regionName ? countryName : null;

        this.state = {
            countryName: countryName,
            regionName: regionName,
            cityName: cityName,
            parentRegion: parentRegion,
            parentCountry: parentCountry,
            imageReference: {},
        };

    }


    componentDidMount() {
        const { countryName, regionName, cityName } = this.state;

        this.mainFetchSequence(countryName, regionName, cityName);

    }

    componentWillReceiveProps(nextProps) {

        if (this.props && nextProps && (this.props.countryCode !== nextProps.countryCode ||
            this.props.regionName !== nextProps.regionName ||
            this.props.cityName !== nextProps.cityName)) {

            const countryName = nextProps.countryCode && nextProps.countryCode !== '' ? getCountryName(nextProps.countryCode) : null;

            this.mainFetchSequence(countryName, nextProps.regionName, nextProps.cityName);

        }
    }

    mainFetchSequence(countryName, regionName, cityName) {
        const urlFragment = cityName && regionName && countryName ? countryName + '/' + regionName + '/' + cityName :
            regionName && countryName ? countryName + '/' + regionName : countryName;


        if (!urlFragment)
            return;

        fetch('/rest/place/image/' + urlFragment + '?portrait=false')
            .then(response => this.validateRestResponse(response))
            .then(response => response.json())
            .then(imageReference => {
                this.setState({
                    imageReference: imageReference,
                    countryName: countryName,
                    regionName: regionName,
                    cityName: cityName
                });
            })
            .catch(e => this.catchRestError(e));
    }

    validateRestResponse(response) {
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(response) {
    }

    render() {
        const { countryName, regionName, cityName, parentRegion, parentCountry, imageReference } = this.state;

        //        const heroImage = require('../assets/image/1920x800/img' + (Math.floor(Math.random() * 17) + 1) + '.jpg');
        //         const heroImage = cityName ?
        //             'https://source.unsplash.com/1920x800/?' + cityName :
        //             regionName ?
        //                 'https://source.unsplash.com/1920x800/?' + regionName :
        //                 'https://source.unsplash.com/1920x800/?' + countryName;

        let imageUrl, authorLink, authorName;
        if (imageReference.imageUrl) {
            imageUrl = "url('" + imageReference.imageUrl + "&w=1920&h=800&fit=crop')";
            authorLink = imageReference.referralAuthorUrl;
            authorName = imageReference.referralAuthorName;
        } else {
            imageUrl = "url('" + Placeholder + "')";
        }

        const imageStyle = {
            height: "130%",
            backgroundImage: imageUrl
        };

        return (
            <div className="dzsparallaxer auto-init height-is-based-on-content mode-scroll"
                data-options='{direction: "normal"}'>
                <div className="divimage dzsparallaxer--target" style={imageStyle} />

                <div className="gradient-x-overlay-lg-dark">
                    <div className="container text-center space-1">
                        <div className="w-lg-50 mx-auto">
                            <h1 className="display-3 font-size-md-down-5 text-white font-weight-semi-bold">{cityName ? cityName : regionName ? regionName : countryName}</h1>
                            {this.renderLinksToParents(parentRegion, parentCountry)}
                            <p className="text-white">{intl.get('place_hero_subtitle')}</p>
                            {this.renderJoinTodayButton()}
                        </div>
                    </div>
                    {
                        authorLink && authorName &&
                        <div className="small text-white-70 text-right overflow-hidden text-nowrap pb-2 pr-4">
                            <img width="12px" height="12px"
                                className="d-inline-block mr-2"
                                src={UnsplashLogo}
                                alt="Unsplash" />
                            <span><a className="text-white-70"
                                target="_blank"
                                rel="noopener noreferrer"
                                href={authorLink}>{authorName}</a></span>
                        </div>
                    }
                </div>
            </div>
        );
    }

    renderLinksToParents(parentRegion, parentCountry) {
        if (!parentRegion && !parentCountry)
            return '';

        return (
            <ul className="list-inline font-size-1 pb-2">
                <li className="list-inline-item">
                    <span className="fas fa-map-marker-alt mr-2" />
                </li>
                {
                    parentRegion &&
                    <li className="list-inline-item">
                        <Link
                            className="text-white link-underline"
                            to={linkForPlace(parentCountry, parentRegion)}>{parentRegion}</Link>
                    </li>
                }
                {
                    parentRegion &&
                    <li className="list-inline-item text-muted">•</li>
                }
                {
                    parentCountry &&
                    <li className="list-inline-item">
                        <Link
                            className="text-white link-underline"
                            to={linkForPlace(parentCountry)}>{parentCountry}</Link>
                    </li>
                }

            </ul>

        )

    }

    renderJoinTodayButton() {
        if (isUserSignedIn(this.context)) {
            return '';
        }

        return (
            <span>
                <a className="btn btn-primary btn-pill btn-wide transition-3d-hover font-size-1"
                   href={getLinkForSignIn(this.context, window.location.href)}>{intl.get('place_hero_join_action')}</a>
            </span>
        )
    }
}

export default PlaceHero;